import React from "react";
import { Search } from "lucide-react";

const inputClass =
  "py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm";

const HistoryFilters = ({
  searchTerm,
  setSearchTerm,
  filterDate,
  setFilterDate,
  filterPillType,
  setFilterPillType,
}) => {
  return (
    <div className="flex flex-wrap sm:flex-nowrap gap-2 mb-6">
      <div className="relative flex-1 min-w-full sm:min-w-0">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 dark:text-gray-500" />
        <input
          type="text"
          placeholder="Search by mother name or barcode..."
          aria-label="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={`w-full pl-10 pr-4 placeholder-gray-500 dark:placeholder-gray-400 ${inputClass}`}
        />
      </div>
      <input
        type="date"
        aria-label="Date Filter"
        value={filterDate}
        onChange={(e) => setFilterDate(e.target.value)}
        className={`flex-1 sm:flex-none px-3 ${inputClass}`}
      />
      <select
        aria-label="Jenis Counting"
        value={filterPillType}
        onChange={(e) => setFilterPillType(e.target.value)}
        className={`flex-1 sm:flex-none px-3 ${inputClass}`}
      >
        <option value="">Semua Jenis</option>
        <option value="MMS Botol">MMS Botol</option>
        <option value="MMS Blister">MMS Blister</option>
        <option value="TTD Capsule">TTD Capsule</option>
      </select>
    </div>
  );
};

export default HistoryFilters;
